import { lazy, Suspense } from 'react'
import DataTable from 'pages/DataTable'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute from './PrivateRouter'
import Spinner from '../components/AntD/Spin'

const Login = lazy(() => import('pages/Login'))
const Main = lazy(() => import('pages/Main'))
const Tutors = lazy(() => import('pages/Tutors'))
const TutorDetail = lazy(() => import('pages/Tutors/Detail'))
const TutorEdit = lazy(() => import('pages/Tutors/Edit'))
const TutorRegisterOne = lazy(() => import('pages/Tutors/Register/One'))
const TutorRegisterBulk = lazy(() => import('pages/Tutors/Register/Bulk'))

const Program = lazy(() => import('pages/Program'))
const ProgramDetail = lazy(() => import('pages/Program/Detail'))
const ProgramEdit = lazy(() => import('pages/Program/Edit'))
const ProgramRegisterOne = lazy(() => import('pages/Program/Register/One'))
const ProgramRegisterBulk = lazy(() => import('pages/Program/Register/Bulk'))

const Report = lazy(() => import('pages/Report'))
const ReportDetail = lazy(() => import('pages/Report/Detail'))

const Statistics = lazy(() => import('pages/Statistics'))
const TotalStatistics = lazy(() => import('pages/Statistics/Total'))

const Contact = lazy(() => import('pages/Contact'))
const ContactView = lazy(() => import('pages/Contact/View'))
const ContactReWrite = lazy(() => import('pages/Contact/ReWrite'))
const ContactWrite = lazy(() => import('pages/Contact/Write'))

const Notice = lazy(() => import('pages/Notice'))
const NoticeView = lazy(() => import('pages/Notice/View'))
const NoticeWrite = lazy(() => import('pages/Notice/Write'))
const NoticeEdit = lazy(() => import('pages/Notice/Edit'))
const FAQ = lazy(() => import('pages/FAQ'))
const FAQView = lazy(() => import('pages/FAQ/View'))
const FAQWrite = lazy(() => import('pages/FAQ/Write'))
const FAQEdit = lazy(() => import('pages/FAQ/Edit'))

const Survey = lazy(() => import('pages/Survey'))
const SurveyDetail = lazy(() => import('pages/Survey/Detail'))
const SurveyRegister = lazy(() => import('pages/Survey/Register'))
const SurveySubmit = lazy(() => import('pages/Survey/Submit'))
const SurveyEdit = lazy(() => import('pages/Survey/Edit'))
const SurveyResponse = lazy(() => import('pages/Survey/Response'))

const Tools = lazy(() => import('pages/Tools/Inventory'))
const ToolsDetail = lazy(() => import('pages/Tools/Inventory/Detail'))
const ToolsEdit = lazy(() => import('pages/Tools/Inventory/Edit'))
const ToolsInventoryRegisterOne = lazy(() => import('pages/Tools/Inventory/Register/One'))
const ToolsInventoryRegisterBulk = lazy(() => import('pages/Tools/Inventory/Register/Bulk'))

const ToolsRental = lazy(() => import('pages/Tools/Rent'))
const ToolsRentalDetail = lazy(() => import('pages/Tools/Rent/Detail'))
const ToolsRentEdit = lazy(() => import('pages/Tools/Rent/Edit'))
const ToolsRentalRegisterBulk = lazy(() => import('pages/Tools/Rent/Register/Bulk'))
const RentalTransfer = lazy(() => import('pages/Tools/Transfer'))

const AccountsPage = lazy(() => import('pages/Accounts'))
const PasswordPage = lazy(() => import('pages/Accounts/password'))

const DecryptTutors = lazy(() => import('pages/DecryptTutors'))

const RedirectPage = lazy(() => import('pages'))
const PageNotFound = lazy(() => import('pages/PageNotFound'))

const Router = () => {
    return (
        <Suspense fallback={<Spinner />}>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route element={<PrivateRoute />}>
                    <Route path="/main" element={<Main />} />
                    <Route path="/program" element={<Program />} />
                    <Route path="/program/:id" element={<ProgramDetail />} />
                    <Route path="/program/edit/:id" element={<ProgramEdit />} />
                    <Route path="/program/register/one" element={<ProgramRegisterOne />} />
                    <Route path="/program/register/bulk" element={<ProgramRegisterBulk />} />

                    <Route path="/tutors" element={<Tutors />} />
                    <Route path="/tutors/:id" element={<TutorDetail />} />
                    <Route path="/tutors/edit/:id" element={<TutorEdit />} />
                    <Route path="/tutors/register/one" element={<TutorRegisterOne />} />
                    <Route path="/tutors/register/bulk" element={<TutorRegisterBulk />} />

                    <Route path="/report" element={<Report />} />
                    <Route path="/report/:id" element={<ReportDetail />} />
                    <Route path="/report/edit/:id" element={<ReportDetail />} />
                    <Route path="/report/register" element={<ReportDetail />} />

                    <Route path="/statistics" element={<Statistics />} />
                    <Route path="/statistics/total" element={<TotalStatistics />} />

                    <Route path="/contact" element={<Contact />} />
                    <Route path="/contact/view/:id" element={<ContactView />} />
                    <Route path="/contact/rewrite" element={<ContactReWrite />} />
                    <Route path="/contact/write" element={<ContactWrite />} />

                    <Route path="/notice" element={<Notice />} />
                    <Route path="/notice/view/:id" element={<NoticeView />} />
                    <Route path="/notice/write" element={<NoticeWrite />} />
                    <Route path="/notice/edit/:id" element={<NoticeEdit />} />
                    <Route path="/contact/faq" element={<FAQ />} />
                    <Route path="/contact/faq/view/:id" element={<FAQView />} />
                    <Route path="/contact/faq/write" element={<FAQWrite />} />
                    <Route path="/contact/faq/edit/:id" element={<FAQEdit />} />

                    <Route path="/tools/inventory" element={<Tools />} />
                    <Route path="/tools/inventory/:id" element={<ToolsDetail />} />
                    <Route path="/tools/inventory/edit/:id" element={<ToolsEdit />} />
                    <Route path="/tools/inventory/register/one" element={<ToolsInventoryRegisterOne />} />
                    <Route path="/tools/inventory/register/bulk" element={<ToolsInventoryRegisterBulk />} />

                    <Route path="/tools/rental" element={<ToolsRental />} />
                    <Route path="/tools/rental/:id" element={<ToolsRentalDetail />} />
                    <Route path="/tools/rental/edit/:id" element={<ToolsRentEdit />} />
                    <Route path="/tools/rental/register/bulk" element={<ToolsRentalRegisterBulk />} />
                    <Route path="/tools/rental/transfer/:id" element={<RentalTransfer />} />

                    <Route path="/survey" element={<Survey />} />
                    <Route path="/survey/:id" element={<SurveyDetail />} />
                    <Route path="/survey/edit/:id" element={<SurveyEdit />} />
                    <Route path="/survey/register" element={<SurveyRegister />} />
                    <Route path="/survey/submit/:id" element={<SurveySubmit />} />
                    <Route path="/survey/response/:id" element={<SurveyResponse />} />

                    <Route path="/accounts" element={<AccountsPage />} />
                    <Route path="/accounts/password" element={<PasswordPage />} />

                    <Route path="/decrypt-tutors" element={<DecryptTutors />} />
                </Route>
                <Route path="/data-table/*" element={<DataTable />} />
                <Route path="/" element={<RedirectPage />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </Suspense>
    )
}

export default Router
